import type { ReactNode } from "react";

type SectionCardProps = {
	title: string;
	description?: string;
	actions?: ReactNode;
	children: ReactNode;
};

const SectionCard: React.FC<SectionCardProps> = ({ title, description, actions, children }) => (
	<section className="flex flex-col gap-4 rounded-xl border border-border-soft bg-surface p-5">
		<div className="flex flex-wrap items-start justify-between gap-3">
			<div className="flex flex-col gap-1">
				<h2 className="text-lg font-semibold text-foreground">{title}</h2>
				{description ? <p className="text-sm text-muted">{description}</p> : null}
			</div>
			{actions ? <div className="flex items-center gap-2">{actions}</div> : null}
		</div>
		{children}
	</section>
);

export default SectionCard;
